interface OpenGiftBoxIconProps {
  size?: number;
  className?: string;
  color?: string;
}

export default function OpenGiftBoxIcon({ size = 24, color = "#FFC640", className = "" }: OpenGiftBoxIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.96931 3.79561C2.08454 3.5613 2.33805 3.42686 2.5954 3.46143L11.9984 4.6368L21.4013 3.46143C21.6587 3.4307 21.9122 3.56514 22.0274 3.79561L23.6292 6.99907C23.9749 7.68662 23.6061 8.52014 22.8686 8.7314L16.5923 10.5252C16.0584 10.6788 15.4861 10.4522 15.2018 9.97591L11.9984 4.6368L8.79491 9.97591C8.51067 10.4522 7.93835 10.6788 7.40444 10.5252L1.13195 8.7314C0.390619 8.52014 0.0257178 7.68662 0.371415 6.99907L1.96931 3.79561ZM12.0406 7.0951L14.1494 10.6058C14.7217 11.5584 15.8625 12.0117 16.9342 11.7044L21.8315 10.3062V16.7208C21.8315 17.5659 21.2554 18.3034 20.4334 18.5108L12.5937 20.4697C12.2019 20.5696 11.791 20.5696 11.403 20.4697L3.56335 18.5108C2.74136 18.2995 2.1652 17.562 2.1652 16.717V10.3024L7.06642 11.7044C8.13424 12.0117 9.27888 11.5584 9.85121 10.6058L11.9561 7.0951H12.0406Z"
        fill={color}
      />
    </svg>
  );
}
